import { render, staticRenderFns } from "./ChannelOfferCaculation.vue?vue&type=template&id=cb2372ac&scoped=true&"
import script from "./ChannelOfferCaculation.vue?vue&type=script&lang=js&"
export * from "./ChannelOfferCaculation.vue?vue&type=script&lang=js&"
import style0 from "./ChannelOfferCaculation.vue?vue&type=style&index=0&id=cb2372ac&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb2372ac",
  null
  
)

export default component.exports